<template>
  <v-layout row wrap class="mt-1">
    <v-flex xs12 md6>
      <unit-card v-show="!unitsLoading" v-for="unit in units" :key="unit.id" :unit-name="unit.name" :unit-code="unit.code" :unit-id="unit.id" unit-quantity="40" @reloadUnits="getUnits()" />
      <h2 v-if="unitsLoading" class="text-xs-center font-weight-light">CARREGANDO UNIDADES, AGUARDE!</h2>
    </v-flex>
    <v-flex xs12 md6>
      <v-form class="unit-form px-3 elevation-2" ref="unitForm" v-model="validForm" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12>
            <v-alert v-model="alert.status" dismissible :type="alert.type">{{ alert.message }}</v-alert>
            <h3 class="mb-2">CADASTRAR NOVA UNIDADE AO SISTEMA.</h3>
            <hr>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="unitData.name" :counter="26" label="NOME, EX: São Paulo, Guarulhos..." :rules="nameRules" required box/>
          </v-flex>
          <v-flex xs12 class="py-0">
            <v-text-field v-model="unitData.code" :counter="3" label="CÓDIGO/SIGLA, EX: SAO, GRU..." :rules="codeRules" required box/>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="success" style="width: 100%;" @click="createUnit()" outline>CADASTRAR</v-btn>
          </v-flex>
          <v-flex xs6 class="mt-0 pt-0">
            <v-btn class="ma-0" color="error" style="width: 100%;" @click="clearForm()" outline>LIMPAR</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import unitCard from '@/components/UnitCard.vue'

export default {
  name: 'units',
  components: { unitCard },
  data() {
    return {
      units: [],
      unitsLoading: true,
      validForm: true,
      unitData: { name: '', code: '' },
      nameRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length >= 6) || 'NOME NÃO PODE TER MENOS DE 06 CARACTERES!',
        v => (v && v.length <= 26) || 'NOME NÃO PODE TER MAIS DE 26 CARACTERES!',
      ],
      codeRules: [
        v => !!v || 'NOME REQUERIDO!',
        v => (v && v.length == 3) || 'CÓDIGO PRECISA TER TRÊS CARACTERES!'
      ],
      alert: {
        message: '',
        type: 'success',
        status: false
      }
    }
  },
  methods: {
    getUnits() {
      this.$http.get('units').then(data => {
        this.units = data.data
        this.unitsLoading = false
      }).catch(err => {
        this.alert.message = err
        this.alert.type = 'error'
        this.alert.status = true
      })
    },
    createUnit() {
      if (this.$refs.unitForm.validate()) {
        this.$http.post('units', this.unitData).then(data => {
          this.alert.message = 'UNIDADE CADASTRADA!'
          this.alert.type = 'success'
          this.alert.status = true
          this.unitsLoading = true
          this.getUnits()
        }).catch(err => {
          this.alert.message = err
          this.alert.type = 'error'
          this.alert.status = true
        })
      } else {
        this.alert.message = 'CAMPOS INCORRETOS!'
        this.alert.type = 'warning'
        this.alert.status = true
      }
    },
    clearForm() {
      this.$refs.unitForm.reset()
    },
  },
  created() {
    this.getUnits()
  }
}
</script>

<style scoped>
  .unit-form {
    background-color: #fff;
  }
</style>
